import { create } from 'zustand';

export const useShowUnavailableAtmsStore = create(set => ({
  showUnavailableAtms: true,
  toggleShowUnavailableAtms: () =>
    set(state => ({ showUnavailableAtms: !state.showUnavailableAtms })),
  setShowUnavailableAtms: showUnavailableAtms => set(() => ({ showUnavailableAtms }))
}));
